import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map, } from 'rxjs/operators';
import { MalingList } from '../models/malingList.model';
import { ContactUs } from '../models/contact-us.model';

@Injectable({
    providedIn: 'root',
})
export class ContactListService {
    constructor(private http: HttpClient) { }

    path = "/contactList/";
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };

    getAllContactUs$(): Observable<ContactUs[]> {
        return this.http.get<ContactUs[]>(environment.apiUrl + this.path + "contactUs/list", this.httpOptions).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }
    addContactUs$(model: ContactUs): Observable<ContactUs> {
        return this.http.post<ContactUs>(environment.apiUrl + this.path + "contactUs", model, this.httpOptions).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }

    deleteContactUs$(id: string): Observable<ContactUs> {
        return this.http.delete<void>(environment.apiUrl + id + "contactUs/" + id, this.httpOptions).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }
    getAllMalingList$(): Observable<MalingList[]> {
        return this.http.get<MalingList[]>(environment.apiUrl + this.path + "malingList/list", this.httpOptions).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }
    addMalingList$(model: MalingList): Observable<MalingList> {
        return this.http.post<MalingList>(environment.apiUrl + this.path, model + "malingList", this.httpOptions).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }

    deleteMalingList$(id: string): Observable<MalingList> {
        return this.http.delete<void>(environment.apiUrl + this.path +"malingList/" + id, this.httpOptions).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }
}
